import styles from "./RectImage.module.scss";
import React from "react";

const RectImage = ({ image, width, height }) => {
  return (
    <div className={styles.rectImage} style={{ ['--image-width']: width !== undefined ? width + 'px' : 'auto', ['--image-height']: height !== undefined ? height + 'px' : 'auto' }}>
      {React.isValidElement(image) ? image : <img src={image} alt="" />}
    </div>
  );
};

export default RectImage;
